import React, { useContext } from 'react';
import { useDyteSelector } from '@dytesdk/react-native-core';
import { defaultIconPack } from '../lib/icons';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import { SvgXml } from 'react-native-svg';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({}) {
  const livestreamUrl = useDyteSelector((m) => m.livestream.playbackUrl);
  const viewType = useDyteSelector((m) => m.meta.viewType);
  const { storeStates, setStates } = useContext(DyteUIContext);
  const [IVSPlayer, setIVSPlayer] = React.useState(null);
  const { colors } = storeStates.designSystem;
  React.useEffect(() => {
    const load = function () {
      try {
        const ivs = require('amazon-ivs-react-native-player');
        setIVSPlayer(ivs.default);
      } catch (err) {
        console.log(
          'Dyte Error: amazon-ivs-react-native-player is not installed'
        );
      }
    };
    load();
  }, []);
  const styles = StyleSheet.create({
    fullscreenButton: {
      position: 'absolute',
      zIndex: 1,
      right: 10,
      top: 10,
      borderRadius: 4,
      backgroundColor: colors.background[900],
    },
  });
  if (viewType === 'LIVESTREAM' && IVSPlayer !== null) {
    return (
      <>
        <View style={styles.fullscreenButton}>
          <TouchableHighlight
            onPress={() => {
              setStates({
                ...storeStates,
                activeFullscreen: !storeStates.activeFullscreen,
              });
            }}
            // eslint-disable-next-line react-native/no-inline-styles
            style={{
              padding: 4,
            }}
          >
            <SvgXml
              xml={(storeStates.activeFullscreen
                ? defaultIconPack.full_screen_minimize
                : defaultIconPack.full_screen_maximize
              ).replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
          </TouchableHighlight>
        </View>
        <IVSPlayer
          autoplay
          liveLowLatency
          streamUrl={livestreamUrl}
          // eslint-disable-next-line react-native/no-inline-styles
          style={{
            flex: 1,
            flexDirection: 'row',
            borderRadius: 8,
            padding: 4,
          }}
        />
      </>
    );
  } else return null;
}
